<template>
    <div class="history-medication">
        <div class="select-patient flexC" v-if="$store.getters.patientData.length == 0 && !$store.getters.selectPatientId" @click="goAddPatient">
            <img src="@/assets/img/addpatient-icon.png" alt="">
            <span class="txt">{{$t("historyMedication.addPpatient")}}</span>
        </div>
        <div class="patient-container" v-else>
            <p class="patient-info" v-if="patinetObj">
                <span class="name">{{$t("bloodPressure.patientname")}}：{{patinetObj.name||'未选择'}}</span>
                <i class="gender-icon"></i>
                <span class="age" v-if="patinetObj.age">{{$t("bloodPressure.age",{age:patinetObj.age})}}</span>
            </p>
            <p class="switch-icon" @click="openSurveyor" v-if="patinetObj" >
                <img src="@/assets/img/switch-icon.png" alt="">
                <span class="txt">{{$t("bloodPressure.switch")}}</span>
            </p>
        </div>
        <div class="medicaltion-emtry flexC" v-if="medicationList.length == 0">
            <img src="@/assets/img/data-null.png" alt="">
            <van-button class="btn-txt" v-if="$store.getters.selectPatientId" plain hairline :disabled="!patinetObj.id" @click="goAdd" icon="plus" size="small">{{$t("historyMedication.addOtherMedicaltion")}}</van-button>
        </div>
        <div class="medication-box" v-else> 
            <div class="medicaltion-item" v-for="(item,index) in medicationList" :key="index">
                <p class="title flexC">
                    <span class="txt">历史用药</span>
                    <van-icon name="edit" @click="goAdd(item.medicationId)" v-if="$store.getters.id == item.cid" />
                </p>
                <div class="item-info flexC">
                    <span class="label">{{$t("historyMedication.medicationName")}}：</span>
                    <div class="input" >
                        <p class="txt" >{{item.medicationName}}</p>
                        <img :src="item.medicationImg" @click="seeImg(item.medicationImg)">
                    </div>
                </div>
                <div class="item-info flexC">
                    <span class="label">{{$t("historyMedication.startTakeDate")}}：</span>
                    <div class="input" >
                        <p class="txt" >{{item.startTime}}</p>
                    </div>
                </div>
                <div class="item-info flexC">
                    <span class="label">{{$t("historyMedication.dxzgc")}}：</span>
                    <div class="input" >
                        <p class="txt" >{{item.takeNum}} 盒</p>
                    </div>
                </div>
                <div class="item-info flexC">
                    <span class="label">{{$t("historyMedication.mqhs")}}：</span>
                    <div class="input" >
                        <p class="txt" >{{item.leftNum}} 盒</p>
                    </div>
                </div>
                <div class="item-info noborder flexC">
                    <span class="label">{{$t("historyMedication.mqfypl")}}：</span>
                    <div class="input" >
                        <p class="txt" >早 {{item.doseAm}} &nbsp;&nbsp;&nbsp; 晚 {{item.dosePm}}</p>
                    </div>
                </div>
            </div>
            <van-button class="btn-txt"  :disabled="!$store.getters.selectPatientId" @click="goAdd" icon="plus" size="small">{{$t("historyMedication.addOtherMedicaltion")}}</van-button>
        </div>
    </div>
</template>

<script>
import { medicationTakelogQuery } from "@/api/user";
import { patientQuery } from "@/api/patient";

export default {
    data () {
        return {
            medicationList:[],
            patinetObj:{}
        }
    },
     computed:{
		getters(){
			return this.$store.getters
		}
	},

    watch:{
        'getters':{
			handler(news,old){
                if(this.$store.getters.selectPatientId&&this.$store.getters.patientData.length!=0){
                    this.patinetObj = this.$store.getters.patientData.find(item => item.id  == this.$store.getters.selectPatientId);
                }
			},
			deep:true
		},
        "patinetObj":{
            handler(){
                this.getMedicationData();
            },
            deep:true
        }
    },
    
    async created () {
        document.title = this.$t("historyMedication.name");
        await this.getPatientData();       
        if(this.$store.getters.patientData.length!=0 && this.$store.getters.selectPatientId){
            // this.patinetObj = this.$store.getters.patientData.find(item => item.id  == this.$store.getters.selectPatientId);
        }
        // console.log(this.patinetObj);
        // this.getMedicationData()
    },
    methods: {
        openSurveyor(){
            let index = this.$store.getters.patientData.findIndex(item => item.id  == this.$store.getters.selectPatientId);
            this.$store.commit("user/SET_PATIENTINDEX",index);
            this.$store.commit("user/SET_SENDPATIENT",true);
        },
        // 获取就诊人数据
		getPatientData(){
			
			patientQuery({}).then(res=>{
				if(res.data.errorCode == 0){
					if(res.data.data.length !== 0){
						this.$store.commit('user/SET_PATIENTDATA',res.data.data);
					}
				}else{
					this.$Toast(this.$t("patient.patientfail"))
				}
			})
		},
        goAddPatient(){
            if(this.$store.getters.patientData.length==0||!this.patinetObj.id){
                this.$router.push({
                    path:"/patient/add"
                })
                return false;
            }
        },
        seeImg(url){
            this.$ImagePreview([url]);
        },
        goAdd(medicationId){
            let query = {
                patientId:this.$store.getters.selectPatientId
            }
            if(medicationId){
                query.medicationId = medicationId;
            }
            this.$router.push({
                path:"/historyMedication/addOrEdit",
                query:query
            })
        },
        getMedicationData(){
            medicationTakelogQuery({userId:this.patinetObj.id}).then(result=>{
                if(result.data.errorCode == 0){
                    this.medicationList = result.data.data;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.history-medication{
    padding: 0.4rem 0.6rem;
    background: #F5F6FA;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    .medication-item{
        background: #fff;
        padding: 0 0.4rem;
        border-radius: 0.32rem;
        box-shadow: 0 0.12rem 0.24rem 0 #DBE1E6;
    }
    .select-patient{
        height: 1.6rem;
        background: #FFEEEA;
        border-radius: 0.16rem;
        border: 2px dashed #FF1A2A;
        justify-content: center;
        font-size: 0.72rem;
        color: #FF1A2A;
        img{
            width: 0.8rem;
            height: 0.8rem;
        }
        .txt{
            margin-left: 0.2rem;
        }
    }
    .medicaltion-emtry,.medication-box{
        flex: 1;
        width: 100%;
    }
    .medication-box{
        overflow: auto;
        .medicaltion-item{
            margin-bottom: 0.6rem;
            background: #fff;
            padding: 0 0.4rem;
            border-radius: 0.32rem;
            box-shadow: 0 0.12rem 0.24rem 0 #DBE1E6;
            .title{
                font-size: 0.72rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #181818;
                line-height: 1rem;
                padding: 0.6rem 0  0.6rem  0.5rem;
                position: relative;
                border-bottom: 1px solid #EDEDED;
                justify-content: space-between;
                &::after{
                    position: absolute;
                    width: 0.2rem;
                    height: 0.72rem;
                    content: " ";
                    left: 0;
                    top: 50%;
                    transform: translate(0,-50%);
                    background: #49A7FF;
                    border-radius: 0.1rem;
                }
                /deep/ .van-icon-edit{
                    font-weight: 600;
                    color: #49A7FF;
                }
            }
            .item-info{
                padding: 0.6rem 0;
                border-bottom: 1px solid #EDEDED;
                align-items: flex-start;
                .label{
                    flex: 0 0 auto;
                    font-size: 0.64rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #181818;
                    line-height: 0.9rem;
                }
                .input{
                    flex: 1;
                    font-size: 0.64rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #181818;

                    img{

                        margin-top: 0.2rem;
                        display: block;
                        width: 2.16rem;
                        height: 2.16rem;
                    }
                }
            }
            .noborder{
                border: 0;
            }
        }
    }
    .medicaltion-emtry{
        flex-direction: column;
        justify-content: center;
        img{
            width: 8rem;
            height: auto;
            margin-bottom: 1rem;
        }
    }
    /deep/ .btn-txt{
        font-size: 0.64rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        height: auto;
        background: none;
        color: #49A7FF;
        line-height: 1rem;
        border-radius: 0.16rem;
        padding:0.2rem 0.6rem;
        border: 0;
        display: block;
        margin: 0 auto;
    }
    .patient-container{
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        position: relative;
        margin-bottom: 0.4rem;
        .switch-icon{
            position: absolute;
            right: -0.6rem;
            width: 3rem;
            height: 1rem;
            background: #49A7FF;
            border-radius: 1rem 0 0 1rem;
            border: 0.02rem solid #FFFFFF;
            top: 50%;
            transform: translate(0, -50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 0.52rem;
                height: 0.48rem;
                margin-right: 00.2rem;
            }
            .txt{
                font-size: 0.56rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.48rem;
            }
        }
        .patient-info{
            .name{
                font-size: 0.64rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
            }
            .gender-icon{
                width: 0.7rem;
                height: 0.7rem;
                margin: 0 0.3rem;
                background: url("~@/assets/img/wan-icon.png") no-repeat;
                background-size: 100% 100%;
            }
            .gender-woman{

            }
            .age{
                font-size: 0.52rem;
                font-family: Helvetica;
                color: #666666;
                padding: 0.08rem 0.3rem;
                border-radius: 00.6rem;
                border: 0.02rem solid #666666;
            }
        }
    }
}
</style>